module.exports = __webpack_public_path__ + "share-01.svg?d09e898908d9dae59dabb23d6f6e9e33";


//////////////////
// WEBPACK FOOTER
// ./src/assets/share-01.svg
// module id = 8
// module chunks = 0